export const FILTERS = [
  {
    options:    'communication_methods',
    cookieName: 'filter_communication_method',
    allLabel:   'Any Communication Method'
  },
  {
    options:    'statuses',
    cookieName: 'filter_status',
    allLabel:   'Any Status'
  },
  {
    options:    'request_modes',
    cookieName: 'filter_request_mode',
    allLabel:   'Any request mode'
  },
  {
    options:    'providers',
    cookieName: 'filter_provider',
    allLabel:   'Any Provider'
  },
  {
    options:    'countries',
    cookieName: 'filter_country',
    allLabel:   'Any Country'
  },
  {
    options:    'states_by_country',
    cookieName: 'filter_state',
    allLabel:   'Any State'
  },
  {
    options: 'age_ranges',
    cookieName: 'filter_age_range',
    allLabel: 'Any Age Range'
  },
  {
    options:    'cancellation_reasons',
    cookieName: 'filter_cancellation_reason',
    allLabel:   'Any Cancellation Reason'
  },
  {
    options:    'consultation_origins',
    cookieName: 'filter_consultation_origin',
    allLabel:   'Internal and External'
  },
  {
    options:    'business_labels',
    cookieName: 'filter_business_label',
    allLabel:   'All'
  }
];

export const DEFAULT_SPECIALTY = 'GENMEDICAL';

export const DEFAULT_ITEMS_PER_PAGE = '50';
export const PER_PAGE_OPTIONS = [
  {
    value: '20',
    text:  '20 per page'
  },
  {
    value: '50',
    text:  '50 per page'
  },
  {
    value: '100',
    text:  '100 per page'
  },
  {
    value: '250',
    text:  '250 per page'
  }
];
